import { BsFillMoonFill, BsMoon } from "react-icons/bs";

import InboxContact from "./contacts";
import OptionsMenu from "../option-menu";
import SearchField from "../search-field";
import SidebarTopicFilters from "./topic-filters";
import Icon from "common/components/icons";
import { useAppTheme } from "common/theme";
import { Inbox } from "common/types/common.type";
import { useChatContext } from "pages/chat/context/chat";
import {
  Actions,
  Avatar,
  CampaignActions,
  CampaignBanner,
  CampaignHeader,
  CampaignLink,
  CampaignLogo,
  CampaignText,
  CampaignTitle,
  ContactContainer,
  Header,
  ImageWrapper,
  ScrollArea,
  SidebarContainer,
  ThemeIconContainer,
} from "./styles";

export default function Sidebar({ isHidden }: { isHidden?: boolean }) {
  const theme = useAppTheme();
  const chatCtx = useChatContext();
  const contactListKey =
    chatCtx.selectedTopics.length === 0
      ? "all-topics"
      : [...chatCtx.selectedTopics].sort().join("|");

  const handleChangeThemeMode = () => {
    theme.onChangeThemeMode();
  };

  const handleChangeChat = (chat: Inbox) => {
    chatCtx.onChangeChat(chat);
  };

  return (
    <SidebarContainer isHidden={isHidden}>
      <Header>
        <ImageWrapper>
          <Avatar
            src={chatCtx.user.image || "/assets/images/feldstein.png"}
            onClick={() =>
              chatCtx.onOpenProfile({
                about: chatCtx.user.role,
                image: chatCtx.user.image || "/assets/images/feldstein.png",
                name: chatCtx.user.name,
              })
            }
          />
        </ImageWrapper>
        <Actions>
          <ThemeIconContainer onClick={handleChangeThemeMode}>
            {theme.mode === "light" ? <BsMoon /> : <BsFillMoonFill />}
          </ThemeIconContainer>
          <button aria-label="Status">
            <Icon id="status" className="icon" />
          </button>
          <button aria-label="New chat" onClick={() => chatCtx.onToggleNewChat(true)}>
            <Icon id="chat" className="icon" />
          </button>
          <OptionsMenu
            iconClassName="icon"
            className="icon"
            ariaLabel="Menu"
            iconId="menu"
            options={[
              "New group",
              "Create a room",
              "Profile",
              "Archived",
              "Starred",
              "Settings",
              "Log out",
            ]}
          />
        </Actions>
      </Header>
      <ScrollArea>
        <SearchField />
        <CampaignBanner>
        <CampaignHeader>
          <div>
            <CampaignTitle>פרויקט מבית הדמוקרטים הצעירים</CampaignTitle>
          </div>
          <CampaignLogo
            alt="הדמוקרטים"
              src="https://democrats.org.il/wp-content/uploads/2025/08/Democratim-logo.svg"
            />
          </CampaignHeader>
          <CampaignText>
            רוצים להצטרף לפעילות, להתעדכן, ולעזור לבנות כוח פוליטי צעיר?
          </CampaignText>
          <CampaignActions>
            <CampaignLink
              href="https://linktr.ee/DemocratsYNG"
              rel="noreferrer"
              target="_blank"
            >
              להצטרפות לדמוקרטים הצעירים
            </CampaignLink>
          </CampaignActions>
        </CampaignBanner>
        <SidebarTopicFilters />
        <ContactContainer key={contactListKey}>
          {chatCtx.inbox.map((inbox) => (
            <InboxContact
              key={inbox.id}
              inbox={inbox}
              isActive={inbox.id === chatCtx.activeChat?.id}
              onChangeChat={handleChangeChat}
            />
          ))}
        </ContactContainer>
      </ScrollArea>
    </SidebarContainer>
  );
}
